import { useEffect, useState, useRef } from 'react';
import '../../assets/styles/_login.scss';

const FacebookCallback = () => {
  const [statusMessage, setStatusMessage] = useState('جاري التحقق من حسابك...');
  const [error, setError] = useState('');
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const errorParam = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    const sendMessage = (type: string, data: any, closeDelay: number = 1000) => {
      if (!window.opener) return;

      window.opener.postMessage({ type, ...data }, '*');
      setTimeout(() => window.close(), closeDelay);
    };

    if (errorParam) {
      const errorMsg = errorDescription
        ? `فشل تسجيل الدخول: ${errorDescription}`
        : `فشل تسجيل الدخول: ${errorParam}`;
      setStatusMessage('حدث خطأ');
      setError(errorMsg);
      sendMessage('FACEBOOK_LOGIN_ERROR', { error: { message: errorMsg } }, 3000);
      return;
    }

    if (!code) {
      const errorMsg = 'لم يتم استلام كود التفويض';
      setStatusMessage('حدث خطأ');
      setError(errorMsg);
      sendMessage('FACEBOOK_LOGIN_ERROR', { error: { message: errorMsg } }, 3000);
      return;
    }

    setStatusMessage('جاري إتمام تسجيل الدخول...');
    sendMessage('FACEBOOK_LOGIN_SUCCESS', { code, provider: 'facebook' });
  }, []);

  return (
    <div className="google-callback-container">
      <div className="loading-container">
        {!error && <div className="spinner" />}
        <h2 className="status-message">{statusMessage}</h2>
        {error && (
          <div className="error-container">
            <div className="error">{error}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FacebookCallback;
